import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { availablePrograms, componentConfigAndMetricsIdsMap, eroiIds, ModalActions, ModifiedFormData, PestTileMap, tvdData, TvdDrillInMetricTiles, TVDLocationDetails, TVDLocationDetailsRowData, TvdLocationServicesDetails, TVDProductDetails, TVDProductDetailsRow, TVDRateDetailsResponse } from '../../types/tvd-types';
import { eroiService } from '../../services/eroi-metric.service';
import { TVDService } from '../../services/tvd.service';
import { TVDModel } from '../../types/tvd-model';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { FiltersService } from 'src/app/core/services/filters.service';
import { CurrencyUomService, UomOption } from 'src/app/core/services/currency-uom.service';
import { ChangeDetectorRef } from '@angular/core';
import { TvdCostAssumptionsService } from '../../services/tvd-cost-assumptions.service';
import { TVDDetailsConfigService } from '../../services/tvd-details-config.service';
import { CapitalizePipe } from 'src/app/core/pipes/capitalize.pipe';
import { CurrencySymbolPipe } from 'src/app/core/pipes/currency-symbol.pipe';
import { TvdDialogInputState } from '../../types/tvd-contract-types';
import { KpiCardLayout, TvdKpiCardBuilder } from '../../builders/tvd-kpi-card-builder';


@Component({
    selector: 'app-tvd-dialog',
    templateUrl: './tvd-dialog.component.html',
    styleUrls: ['./tvd-dialog.component.scss'],
    providers: [CapitalizePipe],
    standalone: false
})
export class TvdDialogComponent {

  @Input() state!: TvdDialogInputState;

  @Output() save = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<string>();

  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;

  makingSelectionsState: boolean = false;

  selectedItemsDict: Map<string, [data:tvdData, isSelected:boolean, isAddedToPres:boolean]> = new Map();
  productivityData: tvdData ={ monetaryContribution: '', valueContribution: '',modifiedMonetaryContribution: '' };
  energyData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
  waterData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };

  tvdProgramScope: string = availablePrograms.ALL;

  isDataAvailableForMetrics:  Map<string, boolean> = new Map([
    [eroiIds.WATER, true],
    [eroiIds.ENERGY, true],
    [eroiIds.PRODUCTIVITY, true],
    [eroiIds.NOCHARGEADDITIONALSERVICES, true],
    [eroiIds.GENERALCONTRACTORCOSTAVOIDANCE, true],
    [eroiIds.SETUPSERVICES, true],
    [eroiIds.PESTPREVENTIONFINDINGS, true],
    [eroiIds.ROOMNIGHTSSAVED, true],
    [eroiIds.FURNITUREPRESERVATIONASSETS, true],
    [eroiIds.FURNITUREPRESERVATIONENERGY, true],
  ]);
  tvdData:TVDModel | undefined;

  // Drilldown TVD data
  tvdProductDetailsData: TVDProductDetails | undefined = undefined;
  tvdLocationDetailsData: TVDLocationDetails | undefined = undefined;

  //Pest drilldown TVD data
  tvdPestLocationDetailsData: TvdLocationServicesDetails | undefined = undefined;

  metricId?: string;
  metricName: string = '';
  metricDisplayName: string = '';
  tabSelected: string = '';

  //left block variables
  imagePath: string = "";
  metricUnits: string = "";
  modifiedTVDDollars: number = 0;
  tvdDollars: number = 0;
  tvdMetricQuantity: number = 0;
  modifiedTvdMetricQuantity: number = 0;

  //right block variables
  totalLocations: string = "0";
  totalContributingProducts: string = "0";
  avgTVDMetricDollars: number = 0;
  modifiedAvgTVDMetricDollars: number = 0;
  avgTVDMetricQuantity: number = 0;

  tvdProductsRowData: TVDProductDetailsRow[] | undefined;
  tvdLocationRowData: TVDLocationDetailsRowData[] | undefined;

  costAssumptionValue: number = 0;
  costAssumptionValue2: number = 0;
  isNoDataAvailable: boolean = true;

  isPestDivision:boolean = false;

  avgMetricUnits: string = 'PE CV $ per No Charge Service';
  hasTwoMetrics: boolean = false;
  hasTwoMultipliers: boolean = false;
  secondaryMetricSum: number = 0;
  totalServices: number = 0;
  tvdRateDetailsResponse: TVDRateDetailsResponse | undefined;
  isScalingFactor = 'scaling factor';

  formattedMetricName: string = '';
  secondMultiplier: number = 1;

  noChargeAdditionalServicesData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
  generalContractorCostAvoidanceData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
  setupServicesData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
  pestPreventionFindingsData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
  roomNightsSavedData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
  furniturePreservationAssetsData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
  furniturePreservationEnergyData: tvdData ={ monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };

  pestMetrics: string[] = [
    eroiIds.NOCHARGEADDITIONALSERVICES,
    eroiIds.GENERALCONTRACTORCOSTAVOIDANCE,
    eroiIds.SETUPSERVICES,
    eroiIds.PESTPREVENTIONFINDINGS,
    eroiIds.ROOMNIGHTSSAVED,
    eroiIds.FURNITUREPRESERVATIONASSETS,
    eroiIds.FURNITUREPRESERVATIONENERGY,
  ];

  ROOMS_NIGHTS_SAVED = PestTileMap[eroiIds.ROOMNIGHTSSAVED];
  SETUP_SERVICES = PestTileMap[eroiIds.SETUPSERVICES];
  NO_CHARGE_ADDITIONAL_SERVICES = PestTileMap[eroiIds.NOCHARGEADDITIONALSERVICES];
    // Backing field for KPI cards bound from the template
   tvdDrillInTitles: TvdDrillInMetricTiles[] = [];
     // No dollar value metrics which should show N/A in drilldowns
  noDollarValueMetrics: string[] = ['Employee Safety', 'Greenhouse Gases', 'CO2e from Energy Use', 'CO2e from Transportation', 'CO2e from Packaging Manufacture'];

  currencyCode: string = '';

  get isDrillDownModal(): boolean {
    return this.state?.isDrillDownModal ?? false;
  }

  constructor(
    private _filterService: FiltersService,
    private _eroiService : eroiService,
    private _tvdService: TVDService,
    private _tvdKpiCardBuilder: TvdKpiCardBuilder,
    private _route: ActivatedRoute,
    private _tvdCostAssumptionsService:TvdCostAssumptionsService,
    private _tvdDetailsConfigService: TVDDetailsConfigService,
    private _currencySymbolPipe: CurrencySymbolPipe,
    private cdr: ChangeDetectorRef,
    private _currencyUomService: CurrencyUomService
  ) { }

  ngOnInit(): void {
    this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe((f) =>
      (this.filters = f)
    );

    this._route.queryParams.subscribe(async (params) => {
      this.metricName = params["metricName"];
      this.tabSelected = params["groupBy"];
      this.metricId = params["metricId"];

      this.metricDisplayName = this.metricName; // Used in UI -- US-514484
        if(this.metricName === "General Contractor (GC) Cost Avoidance") {
          this.metricName = "General Contractor Cost Avoidance";
      }
    });

    this._tvdService.currentProgramSelectedObservable.subscribe((program) => {
        this.tvdProgramScope = program || '';
    });

    this.formattedMetricName = this.metricName?.replace(/[()\-]/g, '').split(" ").join("_").toLowerCase();
    this.isPestDivision = this.filters?.division?.toLowerCase() === 'pest';
    this.hasTwoMetrics = this._tvdDetailsConfigService.hasTwoMetricQuantities(this.metricName);
    this.hasTwoMultipliers = this._tvdDetailsConfigService.hasTwoMultipliers(this.metricName);

    if(this.formattedMetricName === eroiIds.FURNITUREPRESERVATIONASSETS){
      // Set the second multiplier for Furniture Preservation (Assets/Energy) metric
      this.secondMultiplier = this._tvdService.getDefaultRate("furniturepreservationassetsmultiplier", null) as number;
    }

    if (this.isPestDivision) {
      this.initializePestTVDMetricsData();
      this.setPestTVDMetricValues();
    }
    else {
      this.initializeInstitutionalTVDMetricsData();
      this.setTVDMetricValues();
    }

    if(this.state.isDrillDownModal){
      this.buildDrilInTitles();
    }
  }

  buildDrilInTitles(){
    const isNoDollar = this.noDollarValueMetrics.includes(this.metricName);;
    if(this.isPestDivision){
         //Only For Room Nights Saved, we need to show the # of days and its default value and rate. 
         // For other pest metrics, these fields will be blank.
         let rate = 0; let defaultRate = 0;
         if(this.metricName === this.NO_CHARGE_ADDITIONAL_SERVICES || this.metricName === this.SETUP_SERVICES || this.metricName === this.ROOMS_NIGHTS_SAVED){
          const metricId = this.metricName === this.SETUP_SERVICES ? 'setupservicescomultiplier' : 
          this.metricName === this.NO_CHARGE_ADDITIONAL_SERVICES ? 'rodentservicemultiplier' : 'numberofroomnights';
           rate = Number(this.getRate(metricId) ?? 0);
           defaultRate = Number(this.getDefaultRate(metricId) ?? 0);
         }
      this.tvdDrillInTitles = this._tvdKpiCardBuilder.build({
              layout: KpiCardLayout.Pest,
              metricId: this.metricId!,
              metricName: this.metricName,
              currencySymbol: this.getCurrencySymbol(),
              totalContributingProducts: this.totalContributingProducts,
              modifiedTVDDollars: this.modifiedTVDDollars,
              tvdDollars: this.tvdDollars,
              tvdMetricQuantity: this.tvdMetricQuantity,
              modifiedTvdMetricQuantity: this.modifiedTvdMetricQuantity,
              totalLocations: this.totalLocations,
              avgMetricUnits: this.avgMetricUnits,
              modifiedAvgTVDMetricDollars: this.modifiedAvgTVDMetricDollars,
              avgTVDMetricDollars: this.avgTVDMetricDollars,
              avgTVDMetricQuantity: this.avgTVDMetricQuantity,
              hasCostAssumption: this.costAssumptionValue > 0 || this.costAssumptionValue2 > 0,
              costAssumptionValue2: this.costAssumptionValue2,
              hasTwoMetrics: this.hasTwoMetrics,
              secondaryMetricSum: this.secondaryMetricSum,
              rate: rate,
              defaultRate: defaultRate
      },true);
    }else{ //TODO: modify this to use this._tvdKpiCardBuilder.build instead of the method in _tvdService.
      this.tvdDrillInTitles = this._tvdService.buildNonPestKpiCards({
            metricId: this.metricId!,
            costAssumptionValue: this.costAssumptionValue,
            costAssumptionValue2: this.costAssumptionValue2,
            isNoDollar,
            tvdDollars: this.tvdDollars,
            modifiedTVDDollars: this.modifiedTVDDollars,
            metricUnits: this.metricUnits,
            modifiedTvdMetricQuantity: this.modifiedTvdMetricQuantity,
            totalLocations: this.totalLocations,
            totalContributingProducts: this.totalContributingProducts,
            metricName: this.metricName,
            currencySymbol: this.getCurrencySymbol(),
            avgTVDMetricDollars: this.avgTVDMetricDollars,
            modifiedAvgTVDMetricDollars: this.modifiedAvgTVDMetricDollars,
            avgTVDMetricQuantity: this.avgTVDMetricQuantity,
      },true);
    }
  }

  ngAfterViewInit() {
    this.isNoDataAvailable = this.isCheckEmpty();
    this.cdr.detectChanges();
  }

  setTVDMetricValues() {
    if (this.isPestDivision) {
      this.setPestTVDMetricValues();
    } else {
      this.setNonPestTVDMetricValues();
    }
  }

  private setNonPestTVDMetricValues() {
    if (!this.state.drilldownSelectedMetric) {
      console.warn('No metric supplied');
      return;
    }

    // Set common properties
    this.setCommonMetricProperties();

    // Set location/product specific data
    this.setLocationProductData();

    // Calculate average
    this.modifiedAvgTVDMetricDollars = Math.round(this.modifiedTVDDollars / Number(this.totalLocations));
  }

  private setPestTVDMetricValues() {
    if (!this.state.drilldownSelectedMetric) {
      console.warn('No metric supplied');
      return;
    }

    // Set common properties
    this.setCommonMetricProperties();

    // Set pest-specific data
    this.setPestLocationData();
  }

  /**
   * Sets common metric properties for both pest and non-pest divisions.
  */
  private setCommonMetricProperties() {

    const metric = this.state.drilldownSelectedMetric;

    if (!metric) {
      return;
    }

    this.imagePath = this._eroiService.mapIdToMetricIconPath(this.metricId);
    this.metricUnits = this._eroiService.mapIdToUnits(this.metricId);
    this.tvdDollars = Number(metric.monetaryContribution?.replace(/,/g, '')) || 0;
    this.modifiedTVDDollars = Number(metric.modifiedMonetaryContribution?.replace(/,/g, '')) || this.tvdDollars;
    this.tvdMetricQuantity = Number(metric.valueContribution?.replace(/,/g, '')) || 0;
    this.modifiedTvdMetricQuantity = Number(metric.modifiedValueContribution?.replace(/,/g, '')) || this.tvdMetricQuantity;
  }

  // Set location/product specific data for non-pest divisions
  private setLocationProductData() {
    if(this.tabSelected == "location") {
      this.totalLocations = this.tvdLocationDetailsData?.totalLocations!;
      this.totalContributingProducts = this.tvdLocationDetailsData?.totalContributingProducts!;
      this.avgTVDMetricDollars = this._tvdCostAssumptionsService.getFormattedNumber(this.tvdLocationDetailsData?.avgTVDMetricDollars!);
      this.avgTVDMetricQuantity = this._tvdCostAssumptionsService.getFormattedNumber(this.tvdLocationDetailsData?.avgTVDMetricQuantity!);
    } else {
      this.totalLocations = this.tvdProductDetailsData?.totalLocations!;
      this.totalContributingProducts = this.tvdProductDetailsData?.totalContributingProducts!;
      this.avgTVDMetricDollars = this._tvdCostAssumptionsService.getFormattedNumber(this.tvdProductDetailsData?.avgTVDMetricDollars!);
      this.avgTVDMetricQuantity = this._tvdCostAssumptionsService.getFormattedNumber(this.tvdProductDetailsData?.avgTVDMetricQuantity!);
    }
  }

  // Set pest-specific location data
  private setPestLocationData() {
    this.totalLocations = this.tvdPestLocationDetailsData?.totalLocations!;
    this.avgTVDMetricDollars = this._tvdCostAssumptionsService.getFormattedNumber(this.tvdPestLocationDetailsData?.avgPerServiceCost!);
    this.avgMetricUnits = this._tvdDetailsConfigService.getAvgMetricUnitsForPest(this.metricName);
    this.secondaryMetricSum = this._tvdCostAssumptionsService.getFormattedNumber(this.tvdPestLocationDetailsData?.secondaryMetricSum!);
    this.totalServices = this._tvdCostAssumptionsService.getFormattedNumber(this.tvdPestLocationDetailsData?.totalServices!);

    // Calculate modified average
    this.modifiedAvgTVDMetricDollars = Math.round(this.modifiedTVDDollars / (this.totalServices * this.secondMultiplier));

    // Special calculation for Room Nights Saved
    if(this.metricName == "Room Nights Saved") {
      let numberOfDays = this.costAssumptionValue2 > 0 ? this.costAssumptionValue2 : 1;
      this.modifiedAvgTVDMetricDollars = Math.round(this.modifiedTVDDollars / (this.totalServices * numberOfDays * this.secondMultiplier));
    } else if (this._tvdDetailsConfigService.isRetrievalRequiredFromAPI(this.metricName)) {
      this.modifiedAvgTVDMetricDollars = this.costAssumptionValue > 0 ? this.costAssumptionValue : this.avgTVDMetricDollars;
    }
  }

  isDataZeroOrEmpty(tvdData: tvdData,metricId:string): boolean {
    const flag = (tvdData.monetaryContribution === '0' || tvdData.monetaryContribution === '' || tvdData.monetaryContribution === undefined)
    && (tvdData.valueContribution === '0' || tvdData.valueContribution === '' || tvdData.valueContribution === undefined);
    this.isDataAvailableForMetrics.set(metricId, flag);
    return flag;
  }


  isCheckEmpty(): boolean {
    const flag = (Array.from(this.isDataAvailableForMetrics.values()).filter((flag) => flag === true)).length === this.isDataAvailableForMetrics.size;
    return flag;
  }

  getProgramKeys(program: string): string[] {
    let keys = this._eroiService.getProgramKeys(program);
    return keys;
  }

  onSaveClick() {
    this.save.emit();
  }

  /**
   * Resolves the cost assumption values the dialog should render.
   *
   * Preview values travel with the dialog state so that previewing never has to
   * publish them to the shared TVD form data. Saved form data is used only as a
   * fallback for callers that render the dialog without a preview state.
   */
  private getDialogFormData(): ModifiedFormData {
    const previewFormData = this.state?.formData;
    if (previewFormData && Object.keys(previewFormData).length) {
      return previewFormData;
    }
    return this._tvdService.getFormData();
  }
    
  closeDialog(){
    this.closeModal.emit(ModalActions.CLOSE);
    this._tvdService.setTvdModalButtonAction(ModalActions.CLOSE);
    // NOTE: Do NOT reset the saved form data here. Cancelling a preview must
    // leave previously saved cost assumptions untouched.
  }

  getCurrencySymbol() {
    this.currencyCode = this._currencyUomService.getCurrencyCode();
    return this._currencySymbolPipe.transform(this.currencyCode);
  }

  get measurementSystem(): UomOption {
    return this._currencyUomService.getUom();
  }

  /**
   * Initializes the institutional TVD (Total Value Delivery) metrics data by setting up default values,
   * subscribing to observables, and retrieving necessary data for the component.
   *
   * - Sets default values for `productivityData`, `energyData`, and `waterData` based on the component's input data.
   * - Subscribes to the `tvdObservable` from the TVD service to update `tvdData` with the latest data.
   * - Retrieves drilldown metrics for location and product details using the TVD service.
   * - Subscribes to route query parameters to extract `metricName` and `groupBy` values.
   * - Loads saved form data from the TVD service and updates the `costAssumptionValue` based on the metric name.
   *
   * @remarks
   * This method ensures that the component is initialized with the correct data and subscriptions
   * to handle updates dynamically.
   */
  initializeInstitutionalTVDMetricsData() {
    this.productivityData = this.state.previewData.productivityData || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
    this.energyData = this.state.previewData.energyData || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
    this.waterData = this.state.previewData.waterData || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };

    // Subscribe to tvdObservable to get the latest data
    this._tvdService.tvdObservable.subscribe((tvdData: TVDModel | undefined) => {
      this.tvdData = tvdData;
    });

    //Get drilldown metrics value
    this.tvdLocationDetailsData = this._tvdService.getTvdLocationDetailsData();
    this.tvdProductDetailsData = this._tvdService.getTvdProductDetailsData();

    const savedFormData: ModifiedFormData = this.getDialogFormData();
    if (Object.keys(savedFormData).length) {
      let metricName = this.metricName?.toLowerCase();
      if (metricName !== 'productivity') {
        this.costAssumptionValue = Number(savedFormData[metricName]) || 0;
      } else {
        this.costAssumptionValue = this.state.previewData.productivityData ? this._tvdCostAssumptionsService.getFormattedNumber(this.state.previewData.productivityData?.monetaryContribution) : 0;
      }
    }
  }

  /**
   * Initializes the pest TVD (Total Value Delivery) metrics data by assigning default values
   * or existing data from the `pestTVDMetricsData` object. Each metric is assigned a default
   * object containing `monetaryContribution`, `valueContribution`, and `modifiedMonetaryContribution`
   * properties if the corresponding data is not available.
   *
   * The following metrics are initialized:
   * - No Charge Additional Services
   * - General Contractor Cost Avoidance
   * - Set-up Services
   * - Furniture Preservation (Assets)
   * - Furniture Preservation (Energy)
   * - Room Nights Saved
   * - Pest Prevention Findings
   *
   * This method ensures that all metrics have a consistent structure, even if no data is provided.
   */
  initializePestTVDMetricsData() {
    this.fetchTvdRateDetails();

    this._tvdService.tvdObservable.subscribe((tvdData: TVDModel | undefined) => {
      this.tvdData = tvdData;
    });

    this.noChargeAdditionalServicesData = this.state.previewData.pestData?.noChargeAdditionalServicesData || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
    this.generalContractorCostAvoidanceData = this.state.previewData.pestData?.generalContractorCostAvoidance || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
    this.setupServicesData = this.state.previewData.pestData?.setupServices || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
    this.furniturePreservationAssetsData = this.state.previewData.pestData?.furniturePreservationAssets || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
    this.furniturePreservationEnergyData = this.state.previewData.pestData?.furniturePreservationEnergy || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
    this.roomNightsSavedData = this.state.previewData.pestData?.roomNightsSaved || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };
    this.pestPreventionFindingsData = this.state.previewData.pestData?.pestPreventionFindings || { monetaryContribution: '', valueContribution: '', modifiedMonetaryContribution: '' };

    //Get drilldown metrics value
    this.tvdPestLocationDetailsData = this._tvdService.getPestTvdLocationDetailsData();

    const savedFormData: ModifiedFormData = this.getDialogFormData();
    if (Object.keys(savedFormData).length) {
      let formattedMetricName = this.metricName?.replace(/[()\-]/g, '').split(" ").join("_").toLowerCase();
      const metricsIds = componentConfigAndMetricsIdsMap.get(formattedMetricName) || [];
      switch (formattedMetricName) {
        case 'furniture_preservation_energy':
          this.costAssumptionValue = Number(savedFormData[metricsIds[0]]) || 0;
          break;
        default:
          // Standard handling using the map for other metrics
          if (metricsIds && metricsIds.length) {
            if (metricsIds.length === 1) {
              this.costAssumptionValue = Number(savedFormData[metricsIds[0]]) || 0;
            } else {
              this.hasTwoMultipliers = true;
              this.costAssumptionValue = Number(savedFormData[metricsIds[0]]) || 0;
              this.costAssumptionValue2 = Number(savedFormData[metricsIds[1]]) || 0;
            }
          } else {
            this.costAssumptionValue = 0;
          }
      }
    }
  }

  ngDestroy() {
    this.filtersSubscription?.unsubscribe();
  }

  // Rates
  private async fetchTvdRateDetails() {
    try {
      if (this.filters?.division && this.filters.regions) {
        this._tvdService.tvdRateDetailsData$(this.filters.division, this.filters.regions).subscribe({
          next: (data) => {
            this.tvdRateDetailsResponse = data;
            // For pest metrics with rates (Room Nights Saved and Set-up Services, No Charge Additional Services), 
            // we need to build the drill-in titles after fetching the rates to ensure they are included in the titles.
            // build the drill-in titles after fetching the rates to ensure they are included in the titles.
            // This is necessary because the rates are used in the drill-in titles for these metrics, 
            // and we want to ensure that the latest rates are reflected in the titles when the drill-down modal is opened.
            if(this.metricName === this.NO_CHARGE_ADDITIONAL_SERVICES || this.metricName === this.ROOMS_NIGHTS_SAVED  || this.metricName === this.SETUP_SERVICES){
              this.buildDrilInTitles();
            }
           }
        });
      }
    } catch (error) {
      console.error('Unexpected error occurred while fetching TVD Rate Details:', error);
    }
  }

  getRate(metricId:string, isDecimal:boolean=true){
    const savedFormData: ModifiedFormData = this.state.formData ?? {};
    if (savedFormData && savedFormData[metricId]) {
      const rate = savedFormData[metricId];
      return isDecimal ? rate : parseFloat(rate as string)
    }

    return this.getDefaultRate(metricId, isDecimal);
  }

  getDefaultRate(metricId:string,isDecimal:boolean=true){
    let rate = (this.tvdRateDetailsResponse?.tvdRateDetails?.find(x => x.id ===metricId)?.rate ?? 0).toFixed(2);
    return isDecimal ? rate : parseFloat(rate);
  }

  shouldShowDefault(metric: TvdDrillInMetricTiles): boolean {
    return this._tvdKpiCardBuilder.shouldShowDefaultValueForKpiCard(metric);
  }
}
